import { Head, Link, usePage } from '@inertiajs/react'
import Community from './community'
import { CommunityType } from './types'

interface ShowProps {
  community: CommunityType
}

export default function Show({ community }: ShowProps) {
  const { flash } = usePage()

  return (
    <>
      <Head title={`Community #${community.id}`} />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <div className="mx-auto">
          {flash.notice && (
            <p className="py-2 px-3 bg-green-50 mb-5 text-green-500 font-medium rounded-lg inline-block">
              {flash.notice}
            </p>
          )}

          <h1 className="font-bold text-4xl">Community #{community.id}</h1>

          <Community community={community} />

          <Link
            href={`/communities/${community.id}/edit`}
            className="mt-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
          >
            Edit this community
          </Link>
          <Link
            href="/communities"
            className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
          >
            Back to communities
          </Link>
          <div className="inline-block ml-2">
            <Link
              href={`/communities/${community.id}`}
              as="button"
              method="delete"
              className="mt-2 rounded-lg py-3 px-5 bg-gray-100 font-medium"
            >
              Destroy this community
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
